// extracted by mini-css-extract-plugin
module.exports = {"title":"countdown-module--title--31U_m","counter":"countdown-module--counter--1YLrM","mono":"countdown-module--mono--1_YAz"};